import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, Phone } from "lucide-react";
import { PRODUCTS } from "@/data/mockData";
import { SITE_CONFIG } from "@/data/siteConfig";

export default function Shop() {
  return (
    <div data-testid="shop-page" className="bg-cream">
      <section className="bg-bone border-b border-rule py-16 md:py-24">
        <div className="container-wide">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-end">
            <div className="lg:col-span-7">
              <p className="text-sm font-semibold text-forest mb-4">Shop</p>
              <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1]">
                Find something
                <br />
                {" "}<span className="italic text-clay">worth making with.</span>
              </h1>
            </div>
            <div className="lg:col-span-5">
              <p className="text-ink leading-relaxed max-w-lg">
                Shopify is the current Cactus Rose online storefront, cart, and
                checkout. The items below demonstrate the Pass 2 browsing
                experience and are not a live inventory feed.
              </p>
              <a
                href={SITE_CONFIG.links.shopify}
                target="_blank"
                rel="noreferrer"
                className="btn-primary mt-7"
                data-testid="shop-shopify-cta"
              >
                Shop the Live Store
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.7} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="container-wide">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-16 mb-10 md:mb-14">
            <h2 className="lg:col-span-5 font-sans text-3xl md:text-4xl font-semibold">
              Catalog preview
            </h2>
            <p className="lg:col-span-5 lg:col-start-8 text-sm md:text-base text-ink leading-relaxed max-w-xl">
              Product names, colors, specifications, and photography in this
              prototype are illustrative. Confirm current products and pricing
              in Shopify.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 md:gap-x-6 gap-y-12">
            {PRODUCTS.map((product) => (
              <Link
                key={product.id}
                to={`/shop/${product.id}`}
                data-testid={`shop-product-${product.id}`}
                className="group block"
              >
                <div className="aspect-[4/5] overflow-hidden bg-oat">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="mt-4">
                  <p className="text-xs text-ink mb-1">{product.tag}</p>
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="font-sans text-base md:text-lg font-semibold leading-tight">
                      {product.name}
                    </h3>
                    <ArrowRight className="w-4 h-4 shrink-0 text-forest" strokeWidth={1.7} />
                  </div>
                  <p className="text-xs text-ink mt-2">
                    {product.weight} · {product.color}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-cactus-wash border-y border-rule py-16 md:py-20">
        <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
          <div className="md:col-span-8">
            <h2 className="font-sans text-2xl md:text-3xl font-semibold">
              Looking for something specific?
            </h2>
            <p className="mt-3 text-ink leading-relaxed max-w-2xl">
              {SITE_CONFIG.inventory.notice}
            </p>
          </div>
          <div className="md:col-span-4 flex md:justify-end">
            <a href={SITE_CONFIG.phone.href} className="btn-secondary">
              <Phone className="w-4 h-4" strokeWidth={1.7} />
              Call the Shop
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
